function initBuyNowButtons() {
  const buyButtons = document.querySelectorAll('#buy-now, .buy-now__button');

  buyButtons.forEach((buyBtn) => {
    if (buyBtn.dataset.bound) return; // prevent double-binding
    buyBtn.dataset.bound = 'true';

    const form = buyBtn.closest('form, product-form') || document;
    const qtyInput = form.querySelector('[name="quantity"]');
    const variantSelector = form.querySelector('[name="id"]');

    buyBtn.addEventListener('click', async function () {
      buyBtn.disabled = true;

      const variantId = (variantSelector && variantSelector.value) || buyBtn.dataset.variantId;
      const quantity =
        qtyInput && qtyInput.value
          ? parseInt(qtyInput.value, 10)
          : parseInt(buyBtn.dataset.qty || '1', 10);

      if (!variantId) {
        buyBtn.disabled = false;
        return;
      }

      try {
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', quantity);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!res.ok) throw new Error('Could not add item.');

        window.location.href = buyBtn.dataset.checkoutUrl || '/checkout';
      } catch (err) {
        buyBtn.disabled = false;
      }
    });
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', initBuyNowButtons);

// Re-run when Shopify dynamically loads new sections (e.g. in Quick Add drawer)
document.addEventListener('shopify:section:load', initBuyNowButtons);
document.addEventListener('quick-add:loaded', initBuyNowButtons);

// Optional fallback (in case your theme doesn’t emit these events)
const observer = new MutationObserver(() => initBuyNowButtons());
observer.observe(document.body, { childList: true, subtree: true });
